import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import SwitchButton from "./switch-button";
import { Toast } from "../common/toast/toast";

const FileUpload = () => {
  const [toasts, setToasts] = useState([]);
  const [data, setData] = useState([]);
  const [file, setFile] = useState(null);
  const [hearder, setHeader] = useState([]);
  const trialNamesList = useSelector((state) => state.trails_name.data || []);
  const [trailsName, setTrailsName] = useState("");
  const [selectedTrailsNameId, setSelectedTrailsNameId] = useState("");
  const [trialIntro, setTrailIntro] = useState([]);
  const [trialIntroId, setTrailIntroId] = useState("");
  const [trialIntroLabel, setTrailIntroLabel] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [introText, setIntroText] = useState("");
  const [contactPreference, setContactPreference] = useState();
  const contactPreferenceList = [
    { contactPreferenceName: "Call", contactPreferenceVal: "call" },
    { contactPreferenceName: "SMS", contactPreferenceVal: "sms" },
  ];
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    trialIntroId: "",
    trialIntro: "",
  });
  const [phoneNumber, setPhoneNumber] = useState();
  const [apiLoader, setApiLoader] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!firstName) {
      newErrors.firstName = "First name is required.";
    }

    if (!lastName) {
      newErrors.lastName = "Last name is required.";
    }

    if (!phoneNumber) {
      newErrors.phoneNumber = "Select Phone number.";
    }

    if (!selectedTrailsNameId) {
      newErrors.selectedTrailsNameId = "Select Trial.";
    }

    if (!trialIntroLabel) {
      newErrors.trialIntro = "Select Trial Introduction.";
    }

    if (!contactPreference) {
      newErrors.contactPreference = "Contact Preference is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleSelectChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setTrailsName(selectedName);
    const selectedTrailNames = trialNamesList.find(
      (tz) => tz.trialName === selectedName
    );
    setTrailIntro(selectedTrailNames.trialsIntroductionDataModels);
    setSelectedTrailsNameId(selectedTrailNames.trialID);
    setTrailIntroId("");
    setTrailIntroLabel("");
  };

  const handleSelectTrailIntroChange = (e) => {
    const selectedTrailIntroName = e.target.value; // Get the selected timezone
    const selectedTrailIntroduction = trialIntro.find(
      (tz) => tz.trialIntroductionLabel === selectedTrailIntroName
    );
    setTrailIntroId(selectedTrailIntroduction.trialIntroductionID);
    setTrailIntroLabel(selectedTrailIntroduction.trialIntroductionLabel);
  };

  const handleFileUpload = (file) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (result) {
        const headers = result.meta.fields;
        setHeader(headers);
      },
      error: function (error) {
        console.error("Error parsing CSV file:", error);
      },
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "text/csv",
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0 && !file) {
        const uploadedFile = acceptedFiles[0];
        if (
          uploadedFile.type === "text/csv" ||
          uploadedFile.name.endsWith(".csv")
        ) {
          handleFileUpload(uploadedFile);
          setFile(uploadedFile);
        } else {
          addToast("Invalid file type. Please upload a CSV file.", "error");
          console.error("Invalid file type. Please upload a CSV file.");
        }
      }
    },
    disabled: !!file, // Disable dropzone when a file is uploaded
  });

  const removeFile = () => {
    setFile(null);
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) {
      return; // Stop form submission if validation fails
    }
    setApiLoader(true);

    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const stringifyingData = {
      FirstName: firstName,
      LastName: lastName,
      PhoneNumber: phoneNumber,
    };

    const stringData = JSON.stringify(stringifyingData); // Pretty print with 2 spaces
    // const formattedStringData = stringData.replace(/\n/g, '\r\n');
    const formData = new FormData();
    formData.append("File", file);
    formData.append("TrialID", selectedTrailsNameId);
    formData.append("HeaderMatching", stringData);
    formData.append("ClinicalInfoID", "64665802-69d0-4b3f-a76e-08dd1509839f");
    formData.append("TrialIntroductionID", trialIntroId);
    formData.append("ContactPreference", contactPreference);

    try {
      const response = await axios.post(
        ENDPOINTS.PATIENT.BULK_UPLOAD,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setApiLoader(false);
      setFile("");
      setTrailIntro("");
      setTrailIntroId("");
      setTrailIntroLabel("");
      setTrailsName("");
      setFirstName("");
      setTrailIntroLabel("");
      setFirstName("");
      setLastName("");
      setIntroText("");
      setPhoneNumber("");
      addToast("File uploaded successfully!", "success");
    } catch (error) {
      console.error("Error uploading file:", error);
      setApiLoader(false);

      addToast("File upload failed. Please try again.", "error");
    }
  };

  const handleContactSelectChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setContactPreference(selectedName);
  };

  console.log("FileUpload trialIntro", trialIntro);

  return (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      <div className="flex items-center justify-center w-full mt-[30px]">
        <div
          {...getRootProps()}
          className={`flex flex-col items-center justify-center w-full border-2 h-[176px] ${
            file
              ? "border-gray-300 bg-gray-200 cursor-not-allowed"
              : "border-gray-300 bg-gray-50 cursor-pointer hover:bg-gray-100"
          } border-dashed rounded-lg`}
        >
          <div className="flex flex-col items-center justify-center pt-5">
            {file && file.name ? (
              <svg
                className="mb-[16px]"
                width="45"
                height="60"
                viewBox="0 0 55 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M45 13C45 12.6685 44.8683 12.3505 44.6339 12.1161L32.8839 0.366116C32.6495 0.131696 32.3315 0 32 0H1.25C0.559644 0 0 0.559644 0 1.25V58.75C0 59.4404 0.559644 60 1.25 60H35.8423C34.8345 59.2903 33.9263 58.4486 33.1429 57.5H2.5V2.5H30V13.75C30 14.4404 30.5596 15 31.25 15H42.5V35.0561C42.9117 35.019 43.3286 35 43.75 35C44.1714 35 44.5883 35.019 45 35.0561V13ZM36.25 25C36.9404 25 37.5 24.4404 37.5 23.75C37.5 23.0596 36.9404 22.5 36.25 22.5H8.75C8.05964 22.5 7.5 23.0596 7.5 23.75C7.5 24.4404 8.05964 25 8.75 25H36.25ZM26.25 32.5C26.9404 32.5 27.5 31.9404 27.5 31.25C27.5 30.5596 26.9404 30 26.25 30H8.75C8.05964 30 7.5 30.5596 7.5 31.25C7.5 31.9404 8.05964 32.5 8.75 32.5H26.25ZM31.25 40C31.9404 40 32.5 39.4404 32.5 38.75C32.5 38.0596 31.9404 37.5 31.25 37.5H8.75C8.05964 37.5 7.5 38.0596 7.5 38.75C7.5 39.4404 8.05964 40 8.75 40H31.25ZM21.25 47.5C21.9404 47.5 22.5 46.9404 22.5 46.25C22.5 45.5596 21.9404 45 21.25 45H8.75C8.05964 45 7.5 45.5596 7.5 46.25C7.5 46.9404 8.05964 47.5 8.75 47.5H21.25Z"
                  fill="#87909E"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M45 50V53.75C45 54.4404 44.4404 55 43.75 55C43.0596 55 42.5 54.4404 42.5 53.75V50H38.75C38.0596 50 37.5 49.4404 37.5 48.75C37.5 48.0596 38.0596 47.5 38.75 47.5H42.5V43.75C42.5 43.0596 43.0596 42.5 43.75 42.5C44.4404 42.5 45 43.0596 45 43.75V47.5H48.75C49.4404 47.5 50 48.0596 50 48.75C50 49.4404 49.4404 50 48.75 50H45ZM43.75 60C49.9632 60 55 54.9632 55 48.75C55 42.5368 49.9632 37.5 43.75 37.5C37.5368 37.5 32.5 42.5368 32.5 48.75C32.5 54.9632 37.5368 60 43.75 60Z"
                  fill="#87909E"
                />
              </svg>
            ) : (
              <svg
                width="56"
                height="60"
                className="mb-[16px]"
                viewBox="0 0 56 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M45.5 13C45.5 12.6685 45.3683 12.3505 45.1339 12.1161L33.3839 0.366116C33.1495 0.131696 32.8315 0 32.5 0H1.75C1.05964 0 0.5 0.559644 0.5 1.25V58.75C0.5 59.4404 1.05964 60 1.75 60H36.3423C35.3345 59.2903 34.4263 58.4486 33.6429 57.5H3V2.5H30.5V13.75C30.5 14.4404 31.0596 15 31.75 15H43V35.0561C43.4117 35.019 43.8286 35 44.25 35C44.6714 35 45.0883 35.019 45.5 35.0561V13ZM36.75 25C37.4404 25 38 24.4404 38 23.75C38 23.0596 37.4404 22.5 36.75 22.5H9.25C8.55964 22.5 8 23.0596 8 23.75C8 24.4404 8.55964 25 9.25 25H36.75ZM26.75 32.5C27.4404 32.5 28 31.9404 28 31.25C28 30.5596 27.4404 30 26.75 30H9.25C8.55964 30 8 30.5596 8 31.25C8 31.9404 8.55964 32.5 9.25 32.5H26.75ZM31.75 40C32.4404 40 33 39.4404 33 38.75C33 38.0596 32.4404 37.5 31.75 37.5H9.25C8.55964 37.5 8 38.0596 8 38.75C8 39.4404 8.55964 40 9.25 40H31.75ZM21.75 47.5C22.4404 47.5 23 46.9404 23 46.25C23 45.5596 22.4404 45 21.75 45H9.25C8.55964 45 8 45.5596 8 46.25C8 46.9404 8.55964 47.5 9.25 47.5H21.75Z"
                  fill="url(#paint0_linear_1652_131163)"
                  fillOpacity="0.8"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M45.5 50V53.75C45.5 54.4404 44.9404 55 44.25 55C43.5596 55 43 54.4404 43 53.75V50H39.25C38.5596 50 38 49.4404 38 48.75C38 48.0596 38.5596 47.5 39.25 47.5H43V43.75C43 43.0596 43.5596 42.5 44.25 42.5C44.9404 42.5 45.5 43.0596 45.5 43.75V47.5H49.25C49.9404 47.5 50.5 48.0596 50.5 48.75C50.5 49.4404 49.9404 50 49.25 50H45.5ZM44.25 60C50.4632 60 55.5 54.9632 55.5 48.75C55.5 42.5368 50.4632 37.5 44.25 37.5C38.0368 37.5 33 42.5368 33 48.75C33 54.9632 38.0368 60 44.25 60Z"
                  fill="url(#paint1_linear_1652_131163)"
                  fillOpacity="0.8"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1652_131163"
                    x1="23"
                    y1="0"
                    x2="23"
                    y2="60"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#3338BA" />
                    <stop offset="1" stop-color="#630695" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1652_131163"
                    x1="44.25"
                    y1="37.5"
                    x2="44.25"
                    y2="60"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#3338BA" />
                    <stop offset="1" stop-color="#630695" />
                  </linearGradient>
                </defs>
              </svg>
            )}
            <p className="mb-2 text-sm text-gray-500">
              {file ? (
                "File Uploaded"
              ) : (
                <div className="font-mont">
                  <span className="font-mont text-[#245CEA] font-[600]">
                    Select{" "}
                  </span>
                  <span className="text-[##373737]">
                    Or drag and drop file here
                  </span>
                </div>
              )}
            </p>
            <b className="text-xs text-[#202020]">(Supported Format: CSV)</b>
          </div>
          <input {...getInputProps()} />
        </div>
      </div>

      {file && (
        <div className="mt-[30px] flex items-center border border-dashed p-3 rounded-lg bg-gray-50 max-h-screen w-max max-content">
          <div className="mr-1">
            <svg
              width="21"
              height="24"
              viewBox="0 0 21 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.383 7.26461C17.0188 7.43897 18.664 7.50646 20.3081 7.46521L20.3043 7.45865L20.3034 7.45959C18.362 4.52731 15.8554 2.01331 12.9296 0.0644531C12.8865 1.7171 12.954 3.37062 13.1302 5.01494C13.2558 6.09858 14.2973 7.14006 15.3828 7.26473L15.383 7.26461Z"
                fill="#2A70B7"
              />
              <path
                d="M10.1826 9.47642C10.1967 9.33112 10.147 9.18583 10.0458 9.07991C9.94451 8.97398 9.80203 8.9168 9.65579 8.92336C9.50299 8.92992 9.36143 9.00491 9.2705 9.12772C9.17957 9.2477 9.14864 9.40331 9.18707 9.54955C9.353 10.201 9.58736 10.8329 9.88733 11.4356H9.88639C10.0251 10.7897 10.1245 10.1354 10.1836 9.47643L10.1826 9.47642Z"
                fill="#2A70B7"
              />
              <path
                d="M4.81575 19.3501C4.782 19.5939 4.91511 19.8301 5.1401 19.9285C5.36602 20.0279 5.62944 19.9641 5.78504 19.7748C6.27812 19.173 6.7365 18.544 7.15836 17.8896C6.48342 18.1952 5.78974 18.5458 5.08481 18.9489C4.9367 19.0333 4.83732 19.1814 4.81575 19.3501Z"
                fill="#2A70B7"
              />
              <path
                d="M10.2853 14.1338C10.0818 14.7 9.85782 15.2409 9.62158 15.7527C10.2197 15.5652 10.7933 15.4152 11.3333 15.2887C10.9611 14.925 10.6106 14.5388 10.2853 14.1338Z"
                fill="#2A70B7"
              />
              <path
                d="M20.353 8.77753C20.0249 8.78597 19.6996 8.79066 19.3753 8.79066L19.3762 8.79159C17.9954 8.79159 16.6165 8.71754 15.2441 8.5713H15.2328C14.4154 8.47756 13.6111 8.07073 12.9699 7.4286C12.3287 6.78741 11.9219 5.98312 11.8272 5.16569V5.15444L11.8254 5.15257C11.6435 3.44741 11.5741 1.73193 11.6173 0.0175336C9.03849 -0.0452732 6.4578 0.0606551 3.89294 0.335311C2.17937 0.534041 0.536165 2.17639 0.337465 3.88985C-0.112488 8.09497 -0.112488 15.9009 0.337465 20.107C0.536194 21.8206 2.17947 23.4638 3.89294 23.6625C8.08507 24.1125 12.3127 24.1125 16.5048 23.6625C18.2184 23.4638 19.8616 21.8205 20.0603 20.107C20.3668 17.2415 20.4636 12.7072 20.353 8.77753Z"
                fill="#2A70B7"
              />
              <path
                d="M15.1602 15.8618C14.8115 15.8806 14.4009 15.9143 13.9341 15.9696C14.2603 16.1937 14.609 16.4121 14.9802 16.6258H14.9793C15.0871 16.6886 15.2174 16.6971 15.3318 16.6483C15.4518 16.5996 15.5408 16.4965 15.5727 16.3718C15.6046 16.2471 15.5764 16.114 15.4958 16.0128C15.4152 15.9115 15.2896 15.8553 15.1602 15.8618Z"
                fill="#2A70B7"
              />
            </svg>
          </div>
          <div className="text-[14px] text-[##373737] font-mont font-[500]  truncate">
            {file.name}
          </div>
          <button
            onClick={removeFile}
            className="text-red-600 text-sm hover:underline ml-3"
          >
            <svg
              width="15"
              height="18"
              viewBox="0 0 15 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.8281 9.6499L13.4224 9.7326L12.8281 9.6499ZM12.6095 11.2208L13.2038 11.3035V11.3035L12.6095 11.2208ZM2.18475 11.2208L2.77902 11.1381L2.18475 11.2208ZM1.96614 9.64991L1.37186 9.73261L1.96614 9.64991ZM5.05017 17.1144L4.8169 17.6671L5.05017 17.1144ZM2.79304 14.4673L3.35623 14.2603L2.79304 14.4673ZM12.0012 14.4673L12.5644 14.6742L12.0012 14.4673ZM9.7441 17.1144L9.51082 16.5616H9.51082L9.7441 17.1144ZM2.16111 6.44357C2.12977 6.11369 1.83694 5.87167 1.50705 5.90302C1.17716 5.93436 0.935149 6.22719 0.966492 6.55708L2.16111 6.44357ZM13.8278 6.55708C13.8591 6.22719 13.6171 5.93436 13.2872 5.90302C12.9573 5.87167 12.6645 6.11369 12.6332 6.44357L13.8278 6.55708ZM14.0638 5.43366C14.3952 5.43366 14.6638 5.16503 14.6638 4.83366C14.6638 4.50229 14.3952 4.23366 14.0638 4.23366V5.43366ZM0.730469 4.23366C0.399098 4.23366 0.130469 4.50229 0.130469 4.83366C0.130469 5.16503 0.399098 5.43366 0.730469 5.43366V4.23366ZM5.13047 14.0003C5.13047 14.3317 5.3991 14.6003 5.73047 14.6003C6.06184 14.6003 6.33047 14.3317 6.33047 14.0003H5.13047ZM6.33047 7.33366C6.33047 7.00229 6.06184 6.73366 5.73047 6.73366C5.3991 6.73366 5.13047 7.00229 5.13047 7.33366H6.33047ZM8.4638 14.0003C8.4638 14.3317 8.73243 14.6003 9.0638 14.6003C9.39517 14.6003 9.6638 14.3317 9.6638 14.0003H8.4638ZM9.6638 7.33366C9.6638 7.00229 9.39517 6.73366 9.0638 6.73366C8.73243 6.73366 8.4638 7.00229 8.4638 7.33366H9.6638ZM10.7305 4.83366V5.43366H11.3305V4.83366H10.7305ZM4.0638 4.83366H3.4638V5.43366H4.0638V4.83366ZM12.2339 9.5672L12.0152 11.1381L13.2038 11.3035L13.4224 9.7326L12.2339 9.5672ZM2.77902 11.1381L2.56041 9.5672L1.37186 9.73261L1.59048 11.3035L2.77902 11.1381ZM7.39714 16.7337C6.12508 16.7337 5.66439 16.7223 5.28345 16.5616L4.8169 17.6671C5.47536 17.945 6.23287 17.9337 7.39714 17.9337V16.7337ZM1.59048 11.3035C1.82374 12.9796 1.95015 13.9129 2.22985 14.6742L3.35623 14.2603C3.13214 13.6504 3.02095 12.8764 2.77902 11.1381L1.59048 11.3035ZM5.28345 16.5616C4.50662 16.2337 3.78778 15.4349 3.35623 14.2603L2.22985 14.6742C2.74038 16.0637 3.65003 17.1747 4.8169 17.6671L5.28345 16.5616ZM12.0152 11.1381C11.7733 12.8764 11.6621 13.6504 11.438 14.2603L12.5644 14.6742C12.8441 13.9129 12.9705 12.9796 13.2038 11.3035L12.0152 11.1381ZM7.39714 17.9337C8.5614 17.9337 9.31891 17.945 9.97737 17.6671L9.51082 16.5616C9.12988 16.7223 8.66919 16.7337 7.39714 16.7337V17.9337ZM11.438 14.2603C11.0065 15.4349 10.2877 16.2337 9.51082 16.5616L9.97737 17.6671C11.1442 17.1747 12.0539 16.0637 12.5644 14.6742L11.438 14.2603ZM2.56041 9.5672C2.37534 8.23734 2.23702 7.24255 2.16111 6.44357L0.966492 6.55708C1.04545 7.3881 1.18821 8.41296 1.37186 9.73261L2.56041 9.5672ZM13.4224 9.7326C13.6061 8.41295 13.7488 7.3881 13.8278 6.55708L12.6332 6.44357C12.5572 7.24254 12.4189 8.23734 12.2339 9.5672L13.4224 9.7326ZM14.0638 4.23366H0.730469V5.43366H14.0638V4.23366ZM6.33047 14.0003V7.33366H5.13047V14.0003H6.33047ZM9.6638 14.0003V7.33366H8.4638V14.0003H9.6638ZM10.1305 4.00033V4.83366H11.3305V4.00033H10.1305ZM10.7305 4.23366H4.0638V5.43366H10.7305V4.23366ZM4.6638 4.83366V4.00033H3.4638V4.83366H4.6638ZM7.39714 1.26699C8.90671 1.26699 10.1305 2.49075 10.1305 4.00033H11.3305C11.3305 1.82801 9.56946 0.0669922 7.39714 0.0669922V1.26699ZM7.39714 0.0669922C5.22482 0.0669922 3.4638 1.82801 3.4638 4.00033H4.6638C4.6638 2.49075 5.88756 1.26699 7.39714 1.26699V0.0669922Z"
                fill="#060427"
              />
            </svg>
          </button>
        </div>
      )}

      {file && (
        <div>
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div className="relative">
              <label
                htmlFor="clinic"
                className="block font-semibold title_color pb-4"
              >
                First Name <span className="aestrick_color">*</span>
              </label>
              <select
                id="clinic"
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
              >
                <option value="" disabled>
                  Select First Name
                </option>
                {hearder.map((val, idx) => (
                  <option key={idx} value={val}>
                    {val}
                  </option>
                ))}
              </select>
              {errors.firstName && (
                <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.firstName}
                </p>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
            <div className="relative">
              <label
                htmlFor="clinic"
                className="block font-semibold title_color pb-4"
              >
                Last Name <span className="aestrick_color">*</span>
              </label>
              <select
                id="clinic"
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              >
                <option value="" disabled>
                  Select Last Name
                </option>
                {hearder.map((val, idx) => (
                  <option key={idx} value={val}>
                    {val}
                  </option>
                ))}
              </select>
              {errors.lastName && (
                <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.lastName}
                </p>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div className="relative">
              <label
                htmlFor="clinic"
                className="block font-semibold title_color pb-4"
              >
                Phone Number <span className="aestrick_color">*</span>
              </label>
              <select
                id="clinic"
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                }}
              >
                <option value="">Select Phone Number</option>
                {hearder.map((val, idx) => (
                  <option key={idx} value={val}>
                    {val}
                  </option>
                ))}
              </select>
              {errors.phoneNumber && (
                <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.phoneNumber}
                </p>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
            <div className="relative">
              <label
                for="timezone"
                class="block font-semibold title_color pb-4"
              >
                Trial <span className="aestrick_color">*</span>
              </label>
              <select
                id="trailsName"
                name="trailsName"
                value={trailsName}
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none "
                onChange={handleSelectChange}
              >
                <option value={"Select Timezone"} selected>
                  Select Trial
                </option>
                {trialNamesList?.map((tz) => (
                  <option key={tz.trialID} value={tz.trialName}>
                    {tz.trialName}
                  </option>
                ))}
              </select>
              {errors.selectedTrailsNameId && (
                <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.selectedTrailsNameId}
                </p>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8 pt-8 mb-3">
            <div className="relative">
              <label
                for="timezone"
                class="block font-semibold title_color pb-4"
              >
                Intro Text <span className="aestrick_color">*</span>
              </label>
              <select
                id="trialIntroLabel"
                name="trialIntroLabel"
                value={trialIntroLabel}
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectTrailIntroChange}
              >
                <option value={"Select TrialIntroduction"} selected>
                  Select Trial Introduction
                </option>
                {Array.isArray(trialIntro) &&
                  trialIntro.map((tz) => (
                    <option
                      key={tz.trialIntroductionID}
                      value={tz.trialIntroductionLabel}
                    >
                      {tz.trialIntroductionLabel}
                    </option>
                  ))}
              </select>
              {errors.trialIntro && (
                <span className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.trialIntro}
                </span>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
            <div className="w-full relative">
              <label for="timezone" class="block form_label_color pb-4">
                Contact Preference
                <span className="text-red-600"> *</span>
              </label>
              <select
                id="contactPreference"
                name="contactPreference"
                value={contactPreference}
                className="field_bg border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleContactSelectChange}
              >
                <option value={""} selected>
                  Select Contact Preference
                </option>
                {contactPreferenceList?.map((tz) => (
                  <option
                    key={tz.contactPreferenceVal}
                    value={tz.contactPreferenceVal}
                  >
                    {tz.contactPreferenceName}
                  </option>
                ))}
              </select>
              {errors.contactPreference && (
                <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">
                  {errors.contactPreference}
                </p>
              )}
              <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      )}

      {file ? (
        <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-0 w-full -ml-8 bg-white pl-8 flex gap-5 z-10">
          <button
            type="submit"
            onClick={handleSubmit}
            className="px-5 py-2 text-base rounded-md border primary_btn transition-all duration-500"
            disabled={apiLoader}
          >
            {apiLoader ? (
              <div className="flex justify-center">
                <div className="mini-spinner "></div>
              </div>
            ) : (
              "Add"
            )}
          </button>
          <button
            onClick={removeFile}
            type="cancel"
            className="px-5 py-2 text-base rounded-md border secondary_btn transition-all duration-500"
          >
            Cancel
          </button>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default FileUpload;
